import { EventType, EventTypeDetailed } from "@/types";

import { axios } from "../axios.instance";

export type GetMyManagingEventsRequest = {
  perPage?: number;
  cursor?: string;
};

export type GetMyManagingEventsResponse = {
  data: Array<EventType & EventTypeDetailed>;
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getMyManagingEvents = async (params: GetMyManagingEventsRequest): Promise<GetMyManagingEventsResponse> => {
  const { data } = await axios.get(`/events/manage/my`, { params });

  return data;
};
